import { DefaultApiBKO } from './api';
import { TermsResponse } from './types';

export const download = (tag: string) =>
  DefaultApiBKO.request<TermsResponse>(`/terms/${tag}/download`, {
    method: 'GET',
    responseType: 'blob',
  });
